export default __webpack_public_path__ + "static/media/rosn.0aceb743.svg";